import MetricBase from "models/metrics/MetricBase";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricHotelPriceDifferencePercentageRate extends MetricBase {
    constructor() {
        super({
            field: "metric_hotel_price_difference_percentage",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.hotelPriceDifferencePercentageRate.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.hotelPriceDifferencePercentageRate.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.hotelPriceDifferencePercentageRate.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricHotelPriceDifferencePercentageRate;
